import { Form, Radio, Row, Col, Space } from "antd";
import { ContainerForm } from "../styles";
import { useEffect } from "react";
import { Interesse } from "../Interface/Interesse";
import { validarCampos } from "../utils/validadores";

interface FormInteresseProps {
  setFormInteresse: (values: Partial<Interesse>) => void;
  formInteresse: Partial<Interesse>;
  onValidChange: (isValid: boolean) => void;
}

export default function FormInteresse({
  setFormInteresse,
  formInteresse,
  onValidChange,
}: FormInteresseProps) {
  const [form] = Form.useForm();

  const formChange = (_: Partial<Interesse>, allValues: Interesse) => {
    const valores = form.getFieldsValue(["tipoInteresse"]);
    const isValid = validarCampos<Interesse>(valores, ["tipoInteresse"]);

    onValidChange(isValid);
    if (isValid) {
      setFormInteresse(allValues);
    }
  };

  useEffect(() => {
    if (formInteresse) {
      form.setFieldsValue(formInteresse);
    }
  }, [formInteresse, form]);

  return (
    <ContainerForm>
      <Form
        form={form}
        layout="vertical"
        style={{ width: "100%", maxWidth: 600 }}
        onValuesChange={(changedValues, allValues) =>
          formChange(changedValues, allValues)
        }
      >
        <Row gutter={[16, 16]} style={{ maxHeight: "100%", paddingRight: 8 }}>
          <Col xs={24} style={{ textAlign: "center", marginBottom: 24 }}>
            <Form.Item
              name="tipoInteresse"
              label="Tipo de Interesse"
              style={{ fontWeight: 600, fontSize: 16 }}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              rules={[{ required: true, message: "Selecione uma opção." }]}
            >
              <Radio.Group
                style={{
                  background: "#fafafa",
                  padding: 16,
                  borderRadius: 8,
                  display: "inline-block",
                  width: "100%",
                  maxWidth: 400,
                  boxSizing: "border-box",
                }}
              >
                <Space size="large" wrap>
                  <Radio
                    value={"DISPONIBILIZA"}
                    style={{
                      fontSize: 16,
                      padding: "8px 20px",
                      cursor: "pointer",
                      minWidth: 120,
                    }}
                  >
                    Disponibiliza
                  </Radio>
                  <Radio
                    value={"PROCURA"}
                    style={{
                      fontSize: 16,
                      padding: "8px 20px",
                      cursor: "pointer",
                      minWidth: 120,
                    }}
                  >
                    Procura
                  </Radio>
                </Space>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </ContainerForm>
  );
}
